import { deepCopy, isEmpty, findCheck, isArray, applyKey, getKeyOfData } from '@/common/js/utils'
import { android_version, ios_version } from '@/data/baidu/ad_target_data.js'

export function bdCompile (data, orignData) {
  const targetData = deepCopy(orignData)
  let target = deepCopy(data)
  if (isEmpty(target.district)) { // 参数不存在为系统定向
    const defaultData = {
      iosVersion: '0',
      androidVersion: '0',
      lifeStage: '0',
      education: '0'
    }
    target = Object.assign(defaultData, targetData, target)
    target = convertSystemTarget(target)
  }
  const cityItem = { key: 'city', name: '地域' }
  const genderItem = { key: 'gender', name: '性别' }
  const ageItem = { key: 'age', name: '年龄' }
  const includeItem = { key: 'includes', name: '定向人群包' }
  const excludeItem = { key: 'excludes', name: '排除人群包' }
  const interestItem = { key: 'interest', name: '兴趣' }
  const keywordsItem = { key: 'keywords', name: '意图词' }
  const userActionItem = { key: 'userAction', name: '用户行为' }
  const appBehaviorItem = { key: 'app_behavior', name: 'APP定向' }
  const behaviorItem = { key: 'behavior', name: '定向逻辑' }
  const behaviorCateItem = { key: 'behavior_cate', name: 'APP分类' }
  const behaviorAppItem = { key: 'behavior_app', name: 'APP名称' }
  const platformItem = { key: 'platform', name: '操作系统' }
  const androidItem = { key: 'android_osv', name: '安卓版本' }
  const iosItem = { key: 'ios_osv', name: 'iOS版本' }
  const networkItem = { key: 'network', name: '网络' }
  const lifeStageItem = { key: 'lifeStage', name: '人生阶段' }
  const educationItem = { key: 'education', name: '学历' }
  const intelliExtendItem = { key: 'intelli_extend', name: '智能扩量' }
  const filterConvertedItem = { key: 'filter_converted_level', name: '过滤已转化用户' }

  const getName = (item) => {
    return item.name || item.value
  }
  const { cityData, sex, ageMode, age, customAge, audienceData, interestType, interestData, keywordsType, keywordsExtend, keywords, appType, appBehavior, gategoryData, mult_app, device, androidVersion, iosVersion, net, lifeStage, education, autoExpansion, excludeTrans } = target
  const mult_city = findCheck(cityData)
  if (isArray(mult_city) && mult_city.length) cityItem.values = mult_city.map(getName)
  else cityItem.all = true
  if (sex && sex !== '0') genderItem.values = sex === '2' ? ['男'] : ['女']
  else genderItem.all = true
  if (ageMode === 'RANGE') ageItem.values = matchRangeAge(age)
  else if (ageMode === 'CUSTOM') ageItem.values = [`${customAge[0]} ~ ${customAge[1]}`]
  else ageItem.all = true
  const includes = audienceData.filter(ret => ret.select === 'include').map(getName)
  const excludes = audienceData.filter(ret => ret.select === 'exclude').map(getName)
  if (includes.length) includeItem.values = includes
  else includeItem.hide = true
  if (excludes.length) excludeItem.values = excludes
  else excludeItem.hide = true
  const interest = findCheck(interestData)
  if (interestType === 'CUSTOM' && isArray(interest) && interest.length) interestItem.values = interest.map(getName)
  else interestItem.all = true
  if (keywordsType === 'ADD' && isArray(keywords) && keywords.length) {
    keywordsItem.values = keywords
    userActionItem.values = [keywordsExtend === '1' ? '全网行为' : '历史搜索']
  } else {
    userActionItem.all = true
    keywordsItem.all = true
  }
  const gategory = findCheck(gategoryData)
  if (appType === 'category') {
    appBehaviorItem.values = ['APP分类']
    behaviorItem.values = [appBehavior === 2 ? '定向已安装' : '排除已安装']
    behaviorCateItem.values = gategory.map(getName)
    behaviorAppItem.hide = true
  } else if (appType === 'custom') {
    appBehaviorItem.values = ['按APP名称']
    behaviorItem.values = [appBehavior === 2 ? '定向已安装' : '排除已安装']
    behaviorAppItem.values = mult_app.map(getName)
    behaviorCateItem.hide = true
  } else {
    appBehaviorItem.all = true
    behaviorItem.hide = true
    behaviorCateItem.hide = true
    behaviorAppItem.hide = true
  }
  const getNamesByKey = (list, keys) => {
    const names = list.filter(ret => keys.includes(ret.key)).map(ret => ret.label)
    return names && names.length ? names : ['不限']
  }
  if (device === '1') {
    platformItem.values = ['iOS']
    iosItem.values = getNamesByKey(ios_version, iosVersion)
    androidItem.hide = true
  } else if (device === '2') {
    platformItem.values = ['Android']
    androidItem.values = getNamesByKey(android_version, androidVersion)
    iosItem.hide = true
  } else platformItem.all = true
  if (net === '1') networkItem.values = ['WIFI']
  else if (net === '2') networkItem.values = ['移动网络']
  else networkItem.all = true
  if (lifeStage !== '0') lifeStageItem.values = matchLifeStage(lifeStage)
  else lifeStageItem.all = true
  if (education !== '0') educationItem.values = matchEducation(education)
  else educationItem.all = true
  if (autoExpansion === '1') intelliExtendItem.values = ['开启']
  else intelliExtendItem.values = ['关闭']
  if (excludeTrans) filterConvertedItem.values = matchConvert(excludeTrans)
  else filterConvertedItem.values = ['关闭']
  return [cityItem, genderItem, ageItem, includeItem, excludeItem, interestItem, keywordsItem, userActionItem, appBehaviorItem, behaviorItem, behaviorCateItem, behaviorAppItem, platformItem, androidItem, iosItem, networkItem, lifeStageItem, educationItem, intelliExtendItem, filterConvertedItem]
}

export function convertSystemTarget (target) {
  // 逗号分隔的字段变为数组
  const convertKey = ['region', 'customAge', 'age', 'crowd', 'excludeCrowd', 'education', 'iosVersion', 'keywords', 'androidVersion', 'lifeStage', 'newInterests']
  convertKey.forEach(key => {
    target[key] = applyKey(target[key])
  })
  const { crowd, excludeCrowd, region, cityData, newInterests, interestData, mult_gategory, gategoryData } = target
  let { app, audience_dict } = target
  // APP定向
  app = app && JSON.parse(app)
  if (app) {
    const { type, list, behavior } = app
    target.appType = type
    target.appBehavior = (isArray(behavior) && behavior.includes(4) && behavior.length === 1) ? 4 : behavior
    if (type === 'category') target.mult_gategory = list.map(ret => ret.id)
    else if (type === 'custom') target.mult_app = list
  }
  // 地域数据源处理
  if (isArray(region) && region.length) decompile(region, cityData)
  // 兴趣数据源处理
  if (isArray(newInterests) && newInterests.length) decompile(newInterests, interestData)
  // APP分类数据源处理
  if (isArray(mult_gategory) && mult_gategory.length) decompile(mult_gategory, gategoryData)
  // 定向人群包处理
  target.audienceData = []
  if (!isArray(audience_dict)) audience_dict = []
  if (isArray(crowd) && crowd.length) {
    const includes = audience_dict.filter(ret => crowd.includes(ret.id)).map(ret => {
      ret.select = 'include'
      return ret
    })
    target.audienceData.push(...includes)
  }
  if (isArray(excludeCrowd) && excludeCrowd.length) {
    const excludes = audience_dict.filter(ret => excludeCrowd.includes(ret.id)).map(ret => {
      ret.select = 'exclude'
      return ret
    })
    target.audienceData.push(...excludes)
  }
  return target
}

export function matchRangeAge (age) {
  return age.map(ret => {
    switch (ret) {
      case '1':
        return '18岁以下'
      case '2':
        return '18-24岁'
      case '3':
        return '25-34岁'
      case '4':
        return '35-44岁'
      case '5':
        return '45-54岁'
      case '6':
        return '54岁以上'
    }
  })
}

export function matchLifeStage (lifeStage) {
  return lifeStage.map(ret => {
    switch (ret) {
      case '1':
        return '未婚'
      case '2':
        return '已婚'
      case '3':
        return '孕期'
      case '4':
        return '家有儿女'
    }
  })
}

export function matchEducation (education) {
  return education.map(ret => {
    switch (ret) {
      case '1':
        return '大学及以上'
      case '2':
        return '高中及以下'
      case '3':
        return '大专'
    }
  })
}

export function matchConvert (excludeTrans) {
  return [excludeTrans].map(ret => {
    switch (ret) {
      case '0':
        return '不限'
      case '1':
        return '同账户'
      case '2':
        return '同计划'
      case '3':
        return '同单元'
    }
  })
}

export function decompile (Ids, data) {
  const deepSelect = item => {
    item.forEach(ret => {
      if (ret && ret.children && ret.children.length) deepSelect(ret.children)
      if (!ret.disabled) ret.check = true
    })
  }
  if (isArray(Ids) && Ids.length) {
    Ids.forEach(ret => {
      const item = getKeyOfData(data, 'id', Number(ret))
      deepSelect([item])
    })
  }
}
